import "./ContestTerms.css";
import closebutton from "../../assests/closebutton.svg";
import arrow2 from "../../assests/arrow2.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from "react";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";

function ContestTerms({ setShowDetails, terms, heading }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  const { setPreviousLocation } = useUserAuth();
  const { details } = useContext(Context);
  const navigate = useNavigate();

  function createMarkup(theExactHtmlWithTag) {
    return { __html: theExactHtmlWithTag };
  }
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };
  return (
    <div className="contest-terms  text-white ">
      <div
        className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
      >
        {" "}
        <div className=" contest-terms-mainDiv no-scrollbar ">
          <div className="flex justify-between items-center py-[16px] sticky top-0 left-0 bg-black px-[20px]">
            <p className="text-[#0F6ABE] text-privacy">{heading}</p>

            <button
              className="contest-terms-button flex items-center justify-center"
              onClick={() => setShowDetails(false)}
            >
              <img src={closebutton} alt="" className="w-[14px] h-[14px]" />
            </button>
          </div>

          <div className="text-left ol-default ul-default px-[20px]">
            <div
              dangerouslySetInnerHTML={createMarkup(terms?.mainTandc)}
              className="flex flex-col gap-[12px]"
            />
            <br />
            <div
              dangerouslySetInnerHTML={createMarkup(terms?.tandc)}
              className="flex flex-col gap-[12px]"
            />
            {/* <div
          dangerouslySetInnerHTML={createMarkup(
            `<h4> Hello <strong> World </strong></h4>`
          )}
        /> */}
          </div>
          {/* {terms && terms.termsAndConditions && terms.termsAndConditions.map((term, index) => {
        return (
          <p className="contest-terms-description mt-[20px]" key={index}>
            {term.tandc}
          </p>
        );
      })} */}

          {/* <div className='flex justify-end'>
        <button
          onClick={() => {
            setPreviousLocation(window.location.pathname)
            navigate("participate")
          }
          }
          className="terms-card-button flex items-center justify-center mt-[40px]"
        >
          <p className="mr-[10px] terms-card-button-text">Continue</p>
          <img src={arrow2} alt=">" className="terms-card-button-img" />
        </button>
      </div> */}
          <div className="seperator mt-[30px]" />
          <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
        </div>
      </div>
    </div>
  );
}

export default ContestTerms;
